import react, { useContext, useEffect, useState } from "react";
import Activities from "./Activities";
import { useSearchParams, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Packets from "./Packets";
import Profile from "./Profile";
import { UserContext } from "./User";
import DATA from "./Data";
import { doc, updateDoc } from "firebase/firestore";
import db from "../firebase";
import Cookies from "js-cookie";
import ConfettiComp from "./ConfettiComp";
import PopUpMessage from "./PopUpMessage";
import useScore from "../hooks/useScore";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Dashboard() {
	const { user, setUser } = useContext(UserContext);
	const [popUp, setPopUp] = useState(false);
	const [fire, setFire] = useState(false);
	const [popUpMessage, setPopUpMessage] = useState(null);
	const [searchParams] = useSearchParams();
	let unlockParam = searchParams.get("unlock");
	let confirmParam = searchParams.get("confirm");
	const [updateScore] = useScore(10, Cookies.get().id);
	const [pointsModal, setPointsModal] = useState(false);
	const [giftCardUnlocked, setGiftCardUnlocked] = useState(false);
	const navigate = useNavigate();

	const closeModal = () => {
		props.closeModal(false);
	};

	const closePage = () => {
		navigate("/");
	};

	function onModalChange(newState) {   
		setPopUp(newState);
	}

	const completeProfile = () => {
		navigate("/packet_2/bio/5"); // make this dynamic
		Cookies.set("didShowProgressNotificationModuleOne", true);
	};

	let tl = gsap.timeline({
		// yes, we can add it to an entire timeline!
		scrollTrigger: {
			trigger: ".profile",
			pin: false, // pin the trigger element while active
			start: "top top", // when the top of the trigger hits the top of the viewport
			end: "+=1000", // end after scrolling 500px beyond the start
			scrub: true, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
		},
	});

	// tl.call(document.querySelector('.greetings').)
	// tl.to(".greetings", { position: "fixed", top: "0", width: "100%", background: "rgba(0,0,0,0.9)" });

	useEffect(() => {
		if (
			Cookies.get().showProgressNotificationModuleOne &&
			Cookies.get().didShowProgressNotificationModuleOne == "false" &&
			Cookies.get().profileComplete != "true"
		) {
			setPointsModal(true);
			setPopUpMessage(
				`You are 10 pts away from your first reward. Complete your profile to claim.`
			);
			setPopUp(true);
			setFire(true);
		}
		if (!Cookies.get().giftCardEarnedShow && user.score >= 25) {
			setGiftCardUnlocked(true);
			setPopUpMessage("You just unlocked your first reward");
			setPopUp(true);
			setFire(true);
			Cookies.set("giftCardEarnedShow", true);
		}
		if (user.progress) {

			const user_ref = doc(db, "users", Cookies.get().id);
			if (
				user &&
				confirmParam === Cookies.get().id &&
				!user.progress["packet_1"].activities.bio.completed
			) {
				updateDoc(user_ref, {
					"progress.packet_1.activities.bio.completed": true,
				});
				updateScore(10, Cookies.get().id);
			}

			Object.values(DATA.PROGRESS).forEach((packet, i) => {
				if (packet.id === unlockParam) {
					if (i === 0) {
						updateDoc(user_ref, {
							"progress.packet_1.packet_activated": true,
							"progress.packet_1.badge.is_unlocked": true,
						});
						setPopUpMessage("You just unlocked Module One!");
						setPopUp(true);
						setFire(true);
						// setUser({ ...user_ref });
					} else if (i === 1) {
						updateDoc(user_ref, {
							"progress.packet_2.packet_activated": true,
							"progress.packet_2.badge.is_unlocked": true,
							"progress.packet_1.packet_completed": true,
						});
						setPopUpMessage("You just unlocked Module Two!");
						setPopUp(true);
						setFire(true);
					}
				}
			});
		}
	}, [user]);

	return (
		<div className="dashboard">
			<ConfettiComp fire={fire} />
			<PopUpMessage onModalChange={onModalChange} trigger={popUp}>
				{
					<div>
						<h2>Congratulations!</h2>
						<p>{popUpMessage}</p>
						{pointsModal && (
							<button
								style={{ width: "200px", marginBottom: "-35px" }}
								className="bg-blue-400 rounded px-2 py-1 hover:bg-blue-500 text-center text-white font-medium"
								onClick={completeProfile}
							>
								Complete my profile
							</button>
						)}
						{giftCardUnlocked && (
							<button
								style={{ width: "200px", marginBottom: "-35px" }}
								className="bg-blue-400 rounded px-2 py-1 hover:bg-blue-500 text-center text-white font-medium"
								onClick={() => navigate("/rewards")}
							>
								Check my Rewards
							</button>
						)}
					</div>
				}
			</PopUpMessage>
			<Profile />
			<Packets />
			<Footer />
		</div>
	);
}
